export const LINK_TO_PROJECT_MODAL_HEADER = 'Link to an existing project';
export const LINK_PROJECT_BUTTON_TEXT = 'Link project';
export const PROJECT_LINK_SELECT_PLACEHOLDER = 'Select a project to link';
export const NO_MATCHING_PROJECTS_LABEL = 'No matching projects';
export const ALREADY_LINKED_TO_PRO_FORMA_TOOLTIP = 'Already linked to a pro forma';
export const getProjectLinkSelectNote = (assetTypeName: string) => (
    `Only ${assetTypeName} projects are shown so the project's asset type matches this pro forma.`
);
